var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"component",staticClass:"lz-nav-icon",class:_vm.cssClasses,on:{"click":_vm.onClick}},[_c('div',{staticClass:"lz-nav-icon__icon"},[_vm._t("icon")],2),_c('div',{staticClass:"lz-nav-icon__label"},[_vm._t("label")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }